import React, {useCallback, useEffect, useState} from 'react';
import FacilityListTableComponent from "./facility-list-table/FacilityListTableComponent";
import {CommonService} from "../../shared/services";
import AddIcon from '@mui/icons-material/Add';
import {Download} from "@mui/icons-material";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import {Link} from "react-router-dom";
import {IAPIResponseType} from "../../shared/models/api.model";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import DrawerComponent from "../../shared/components/drawer/drawerComponent";
import FacilityFiltersComponent from "./facility-filters/FacilityFiltersComponent";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import {IRootReducerState} from "../../store/reducers";
import _ from "lodash";
import SearchComponent from "../../shared/components/search/SearchComponent";
import commonService from "../../shared/services/common.service";

interface FacilityListScreenProps {

};


const FiltersInitialState: any = {
    search: '',
    types:[],//facilityTypes: [],sending as types
    facilityTypesObjs: [],
    createdByObjs: [],
    createdByIds: [],
    statuses: [],
    statusesObjs: [],
    cities: [],
    citiesObjs: [],
    startDate: '',
    endDate: ''
}

const FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS = ['statusesObjs', 'createdByObjs', 'facilityTypesObjs', 'citiesObjs'];

const FacilityListScreen = (props: FacilityListScreenProps) => {
    const [isCSVDownloading, setIsCSVDownloading] = useState<boolean>(false);
    const [showFilterDrawer, setShowFiltersDrawer] = useState<boolean>(false);
    const dispatch = useDispatch();
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const {
        facilityStatusList,
        facilityTypesList,
        userList,
        citiesListLite
    } = useSelector((state: IRootReducerState) => state.staticData);
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));


    useEffect(() => {
        dispatch(setCurrentNavParams("Facility", "Facility"));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    const downloadCSV = useCallback(() => {
        const payload = {...filterData};
        setIsCSVDownloading(true);
        CommonService._facility.downloadFacilityCSV(payload)
            .then((response: IAPIResponseType<any>) => {
                setIsCSVDownloading(false);
                if (response && response?.data && response?.data?.attachmentUrl) {
                    CommonService.downloadFile(response?.data?.attachmentUrl, response?.data?.title || 'facility.csv', 'csv');
                }
            })
            .catch((error: any) => {
                setIsCSVDownloading(false);
            });
    }, [filterData]);

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    useEffect(() => {
        if (queryParamData) {
            const data: any = {
                search: queryParamData.search || '',
                startDate: queryParamData.startDate || '',
                endDate: queryParamData.endDate || '',
            };
            if (queryParamData?.statuses?.length) {
                data['statuses'] = queryParamData.statuses.split(',') || [];
            }
            data['statusesObjs'] = facilityStatusList.filter((item: any) => data['statuses']?.includes(item?.code));

            if (queryParamData?.createdByIds?.length) {
                data['createdByIds'] = queryParamData.createdByIds.split(',') || [];
            }
            data['createdByObjs'] = userList.filter((item: any) => data['createdByIds']?.includes(item?.id?.toString()));

            if (queryParamData?.types?.length) {//facility types
                data['types'] = queryParamData.types.split(',') || [];
            }
            data['facilityTypesObjs'] = facilityTypesList.filter((item: any) => data['types']?.includes(item?.code));

            if (queryParamData?.cities?.length) {
                data['cities'] = queryParamData.cities.split(',') || [];
            }
            data['citiesObjs'] = citiesListLite.filter((item: any) => data['cities']?.includes(item?.city));

            setFilterData((prevState: any) => ({
                ...prevState, ...data
            }));
        }
    }, [queryParamData, citiesListLite, facilityStatusList, facilityTypesList, userList]);

    const applyFilters = useCallback((filterData: any) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            ...filterData
        }));
        setShowFiltersDrawer(false);
    }, []);

    useEffect(() => {
        CommonService.mapFilterDataToQueryParams(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS);
    }, [filterData]);

    const clearAllFilters = useCallback(() => {
        setFilterData(_.cloneDeep(FiltersInitialState));
    }, []);


    return (
        <div className="facility-list-screen screen">
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search"}
                                id="search_input"
                                placeholder={"Search by facility name"}
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>

                        <div className="page-extra-options">
                            {
                                CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 &&
                                <ButtonComponent
                                    type="button"
                                    id="clear_all_filters"
                                    className={"clear-all-filters"}
                                    color={"secondary"}
                                    variant={"text"}
                                    fullWidth={false}
                                    handleClick={clearAllFilters}
                                >
                                    Clear All
                                </ButtonComponent>
                            }
                            <ButtonComponent
                                type="button"
                                id="csv_btn"
                                color={"primary"}
                                variant={"outlined"}
                                fullWidth={false}
                                handleClick={() => setShowFiltersDrawer(true)}
                                startIcon={<FilterAltIcon/>}>
                                Filters {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 ? `( ${CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS)} )` : ''}
                            </ButtonComponent>
                            {
                                commonService.checkAccess('Facility',
                                    "facilityCsvDownload", currentUser?.userAccessModules) &&
                                <ButtonComponent
                                    type="button"
                                    id="csv_btn"
                                    color={"secondary"}
                                    variant={"outlined"}
                                    fullWidth={false}
                                    isLoading={isCSVDownloading}
                                    handleClick={downloadCSV}
                                    disabled={isCSVDownloading}
                                    startIcon={<Download/>}
                                >
                                    CSV
                                </ButtonComponent>
                            }
                            {
                                commonService.checkAccess('Facility',
                                    'facilityAdd', currentUser?.userAccessModules) &&

                                <Link to={CommonService._routeConfig.FacilityAddRoute()}>
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"contained"}
                                        id="add_facility_button"
                                        startIcon={<AddIcon/>}
                                    >
                                        New Facility
                                    </ButtonComponent>
                                </Link>
                            }
                        </div>
                    </div>
                    <div className="page-data-wrapper">
                        <FacilityListTableComponent filterData={filterData}/>
                    </div>
                </div>
            </div>

            <DrawerComponent open={showFilterDrawer}
                             className={"drawer-wrapper"}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             onClose={() => setShowFiltersDrawer(false)}
            >
                <FacilityFiltersComponent filtersData={filterData} onFiltersApply={applyFilters}
                                          clearAllFilters={clearAllFilters}/>
            </DrawerComponent>

        </div>
    );
};

export default FacilityListScreen;
